import EnquiryForm from "../components/common/EnquiryForm";

export default function LegalTerms() {
  return (
    <main className="pt-16 md:pt-20">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-semibold text-gray-900 mb-8">Legal Terms</h1>

        <div className="flex flex-col gap-8">
          <div className="text-gray-600 text-sm leading-relaxed flex flex-col gap-4">
            <p>
              The information contained in this website is for general information purposes only. The information
              is provided by Artistic Spaces and while we endeavour to keep the information up to date and
              correct, we make no representations or warranties of any kind, express or implied, about the
              completeness, accuracy, reliability, suitability or availability with respect to the website or the
              information, products, services, or related graphics contained on the website for any purpose. Any
              reliance you place on such information is therefore strictly at your own risk.
            </p>
            <p>
              In no event will we be liable for any loss or damage including without limitation, indirect or
              consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits
              arising out of, or in connection with, the use of this website.
            </p>
            <p>
              Through this website you may be able to link to other websites which are not under the control of
              Artistic Spaces. We have no control over the nature, content and availability of those sites. The
              inclusion of any links does not necessarily imply a recommendation or endorse the views expressed
              within them.
            </p>
            <p>
              Every effort is made to keep the website up and running smoothly. However, Artistic Spaces takes no
              responsibility for, and will not be liable for, the website being temporarily unavailable due to
              technical issues beyond our control.
            </p>
          </div>

          <Section title="Terms and Conditions for Website Usage">
            <p className="mb-4">
              Welcome to our website. If you continue to browse and use this website, you are agreeing to comply
              with and be bound by the following terms and conditions of use, which together with our privacy
              policy govern Artistic Spaces' relationship with you in relation to this website.
            </p>
            <p className="mb-4">
              The term 'Artistic Spaces', 'us' or 'we' refers to the owner of the website whose registered office
              is 20a Ironmonger Lane, London, United Kingdom, EC2V 8EP. Company registration number: 07150124
              (Registered in England and Wales). The term 'you' refers to the user or viewer of our website.
            </p>
            <ul className="flex flex-col gap-3">
              {[
                "The content of the pages of this website is for your general information and use only. It is subject to change without notice.",
                "This website uses cookies to monitor browsing preferences.",
                "Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose.",
                "Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable.",
                "This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice.",
                "Unauthorised use of this website may give rise to a claim for damages and/or be a criminal offence.",
                "From time to time this website may also include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s).",
                "Your use of this website and any dispute arising out of such use of the website is subject to the laws of England, Northern Ireland, Scotland and Wales.",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="text-teal-600 mt-0.5 flex-shrink-0">—</span>
                  {item}
                </li>
              ))}
            </ul>
          </Section>

          <Section title="Copyright Notice">
            <p className="mb-3">
              This website and its content is copyright of Artistic Spaces. All rights reserved.
            </p>
            <p>
              You may not, except with our express written permission, distribute or commercially exploit the
              content. Nor may you transmit it or store it in any other website or other form of electronic
              retrieval system.
            </p>
          </Section>

          <Section title="Links to Other Websites">
            <p>
              Our website may contain links to other websites of interest. However, once you have used these links
              to leave our site, we do not have any control over that other website. Therefore, we cannot be
              responsible for the protection and privacy of any information which you provide whilst visiting such
              sites. You should exercise caution and look at the privacy statement applicable to the website in
              question.
            </p>
          </Section>
        </div>
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/legal-terms" pageName="Legal Terms" />
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-3">{title}</h2>
      <div className="text-gray-600 text-sm leading-relaxed">{children}</div>
    </div>
  );
}